import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { AddressType } from '../models';
import { AbstractApiResponse } from '../../shared/models';
import { AbstractApiService } from '../../shared/services';
import { UserRoleService } from '../../shared/services/user-role.service';

@Injectable()
export class AddressTypesService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  readAddressType(iri: string): Observable<AddressType> {
    return this.rolesService.userHasRoleFilter<AddressType>(
      'ROLE_MWS_ADDRESS_TYPE_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  readAddressTypes(): Observable<AbstractApiResponse> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_ADDRESS_TYPE_LIST',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(`/address_types`)
    );
  }
}
